import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=4644f0cc&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4644f0cc')) {
      api.createRecord('4644f0cc', component.options)
    } else {
      api.reload('4644f0cc', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=4644f0cc&", function () {
      api.rerender('4644f0cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jSnPnaVI85WZ/JS/pricehelp.vue"
export default component.exports